import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import LegalSuggest from '../Dadata/LegalSuggest';
import { DadataInnResponse } from '../../structures/response/dadata/DadataInnResponse';
import { DadataLegalType } from '../../enum/DadataLegalType';

interface Props extends FieldRenderProps<string> {
  legalType: DadataLegalType;
  onItemSelected: (data: DadataInnResponse) => void;
}

export default ({ input: { onChange, value, onBlur }, ...rest }: Props) => (
  <LegalSuggest {...rest} onChange={onChange} onBlur={onBlur} value={value} />
);
